export type SearchFormTypes = {
  types: number[]
}
export const useSearchFiltersFormTypes = (formRef: Ref<SearchFormTypes> | undefined = undefined) => {
  const { filters } = storeToRefs(useSearchStore())

  const formTypes = formRef === undefined
    ? ref<SearchFormTypes>({
        types: [],
      })
    : formRef

  const initFormTypes = () => {
    if (Array.isArray(filters.value.types)) {
      formTypes.value.types = filters.value.types.map((type) => {
        if (typeof type === 'string') {
          return parseInt(type)
        }
        return type
      })
    }
    else if (filters.value.types) {
      formTypes.value.types = [filters.value.types]
    }
    else {
      formTypes.value.types = []
    }
  }
  return {
    formTypes,
    initFormTypes,
  }
}
